import {cva as cvaBase, type VariantProps} from 'class-variance-authority';
import {clsx, type ClassValue} from 'clsx';
import {twMerge} from 'tailwind-merge';

// Re-export cva with automatic tailwind-merge on the result
// Uses standard CVA API: cva(base, config)
export const cva: typeof cvaBase = (base, config) => {
  const variantFn = cvaBase(base, config);
  return (props) => twMerge(variantFn(props));
};

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const cx = cn;

export type {VariantProps};
